import { DataBean } from "../DataBean";

export class PdfLibraryFactory extends DataBean {
    
    

    public async getPdfLibraryFactoryCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CacheOptions", "java.util.List_getPdfLibraryFactoryCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

}